
import CollapseTransition from "~/components/shared/CollapseTransition.vue";

export default {
  name: "AccordionBlock",
  components: { CollapseTransition },
  props: {
    data: {
      type: Object,
      required: true,
    },
    accordion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeItems: [],
    };
  },
  computed: {
    isBlockActive() {
      return (idx) => this.activeItems.includes(idx);
    },
  },
  methods: {
    toggleActive(idx) {
      if (this.accordion) {
        this.activeItems = this.activeItems.includes(idx) ? [] : [idx];
        return;
      }

      if (this.activeItems.includes(idx)) {
        this.activeItems = this.activeItems.filter((item) => item !== idx);
      } else {
        this.activeItems.push(idx);
      }
    },
  },
};
